<template>
  <div class="mobile-cart-title">
    <h4>
      {{
        cart_items_count ? _T_DB(brand, 'company_name') : _T('Cart is empty')
      }}
    </h4>
    <a href="javascript:void(0)" @click="gotoCatalogPage()">
      <svg class="back" fill="none">
        <use xlink:href="#left_arrow" />
      </svg>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'currentBrand',
      '_T_DB',
      'cart_brand_store',
      'cart_items_count',
      '_T',
      'brandStoreRoute',
      'brandStoreParams',
    ]),
    brand() {
      return this.cart_brand_store.brand || this.currentBrand || ''
    },
  },
  methods: {
    gotoCatalogPage() {
      this.$router.push({
        name: this.brandStoreRoute('store_page'),
        params: {
          ...this.brandStoreParams,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-cart-title {
  background-color: $white;
  text-align: center;
  padding: $px11;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  h4 {
    font-weight: bold;
    font-size: $px18;
    line-height: $px22;
    color: $font-color;
    text-transform: capitalize;
    margin-bottom: 0;
  }
  a {
    position: absolute;
    left: $px20;
    top: $px8;
    .back {
      width: $px24;
      height: $px24;
    }
  }
}
</style>
